// 서사 축의 직업 방향. 막 내용이 있는 축은 그 막의 방향을, 없는 축은 격국 기본 직업 분야를 돌려준다.
// 데이터는 arcData.js (자동 생성). 방향은 게임 규칙이며 직업 이름을 고서가 정했다는 뜻이 아니다.
import { ARC_DATA } from './arcData.js';
import { actOf } from './arc.js';

/**
 * essence(본질)와 나이로 직업 방향을 구한다.
 * { fields, traits, source: 'arc' | 'default', cardIds, theme } — 본질이 없으면 null.
 * 15세 미만은 1막으로 본다.
 */
export function directionFor(essence, age) {
  const arcId = essence?.arcId?.value;
  if (!arcId) return null;
  const act = actOf(age) ?? 1;
  const arc = ARC_DATA.arcs[arcId];
  const actData = arc?.acts.find((a) => a.act === act);
  if (actData) return { fields: [...actData.fields], traits: [...actData.traits], source: 'arc', cardIds: [...actData.cardIds], theme: actData.theme };
  const fallback = ARC_DATA.defaults[arcId];
  if (!fallback) return null;
  return { fields: [...fallback.fields], traits: [], source: 'default', cardIds: [...essence.arcId.cardIds], theme: null };
}
